import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const PayableInvoicesListConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "PayableInvoicesList" */
      '../../../components/Treasury/PayableInvoicesList/PayableInvoicesList'
    ),
  teamOwner: 'treasury',
  sentryTeam: 'treasury_surfaces',
  enabledKey: 'internal',
  releaseState: 'internal',
  description: 'A list of payable invoices for a connected account.',
  friendlyName: 'Payable invoices list',
};
